export default "/assets/images/slide-mini-lg.jpg?6a9e8cd008c7b9a8a8f95e6479ae5c23";